module.exports = __webpack_public_path__ + "static/media/suman-deb.7e04ed4e.png";